import { createRouter, createWebHashHistory } from 'vue-router'

import LayOut from '../views/Layout/LayOut.vue'
import store from '../store/index.js'
import getPageTitle from '@/util/get-page-title'

const routes = [
  {
    path: "/login",
    name: 'login',
    component: () => import("../views/pages/Login.vue")
  },
  {
    path: "/register",
    name: 'register',
    component: () => import("../views/pages/Register.vue")
  },
  {
    path: "/",
    name: 'layout',
    component: LayOut,
    redirect: "/contract",
    // 子路由
    children: [
      {
        path: "/contract",
        name: "contract",
        component: () => import("../views/pages/Contract.vue")
      },
      {
        path: "/sign",
        name: "sign",
        component: () => import("../views/pages/Sign.vue")
      }

    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = getPageTitle(to.meta.title)
  /**
   * to： 从哪个页面
   * from： 到哪个页面
   * next：只有执行next，页面才会进行跳转
   */
  // 判断用户是否登录
  const uInfo = store.state.uInfo.userInfo;
  if (!uInfo) {
    //未登录，跳转到login
    if (to.path === '/login') {
      next()
      return
    }
    next("/login")
  } else {
    next()
  }

})

export default router
